module.exports = __webpack_public_path__ + "img/check-green.6b7271aa.svg";